//#region import
import React, { useEffect, useState } from 'react'
import { Box, Chip, Grid, IconButton, Popover, Tooltip, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router';
import { FnAxios, FnDialog } from 'utilities/utilities';
import DataGrid, { PaginationInterface, initRows } from 'components/DataGrid';
import { BtnAddOnTable, BtnEditOnTable, BtnViewOnTable } from 'components/Button/ButtonTable';
import DialogPreview from 'components/DialogPreview/DialogPreview';
import SubjectIcon from "@mui/icons-material/Subject";
import { Circle } from '@mui/icons-material';
import { FilterFieldInterface } from 'components/DataGrid/DataGridProps';
import ChangeOrder from '../../../../components/System/ChangeOrder';
import { EnumStatus } from '../Role/RoleList';
import { GetMenuPermission } from 'utilities/SystemFunction';
import InfoIcon from '@mui/icons-material/Info';
//#endregion

const GroupList = () => {
    const navigate = useNavigate();
    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const location = useLocation();
    const [lstOrder, setLstOrder] = useState<any>([]);
    const [loadingTable, setLoadingTable] = useState(false);
    const [isOpenPermission, setisOpenPermission] = useState<boolean>(false);
    const [lstPermission, setLstPermission] = useState([]);
    const [sUpdateName, setUpdateName] = useState(null);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "nOrder",
        sSortDirection: "asc"

    });
    const [arrUserRole, setarrUserRole] = useState<any>([]);
    const getFormInitial = () => {
        AxiosFn.Get(`Group/getFormInitial`, {}, (result) => {
            setarrUserRole(result.lstDataPerm);
        })
    }
    const [isPermission, setPermission] = useState<boolean>(false); // Permission

    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);
    }, []);

    const handleViewInfo = (e) => {
        setUpdateName(e.sUpdateName);//sUpdateName
    }
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);

    const dataColumn: any = [
        {
            renderHeader: (item) => (
                <>
                    <BtnAddOnTable
                        IsDisabled={!isPermission}
                        onClick={() => navigate(`/GroupForm`)} id={"Add"} />
                </>
            ),
            field: "ปุ่ม (เพิ่ม/แก้ไข)",
            align: "center",
            type: "actions",
            resizable: false,
            sortable: false,
            width: 60,
            flex: 0.2,
            getActions: (item) => {
                if (!isPermission) {
                    return [
                        <BtnViewOnTable
                            id="btnView"
                            key={item.row.sID}
                            onClick={() => goToEdit(item.row.sID)}
                        />
                    ];
                } else {
                    return [
                        <BtnEditOnTable
                            key={item.row.sID}
                            id="btnEdit"
                            onClick={() => goToEdit(item.row.sID)}
                        />
                    ];
                }
            },
        },
        {
            field: "nOrder",
            headerName: "ลำดับ",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 100,
            flex: 0.5,
            renderCell: (item) => {
                return (
                    <ChangeOrder
                        item={item}
                        value={item.row.nOrder}
                        onChangeOrder={onChangeOrder}
                        optOrder={lstOrder}
                        disabled={!isPermission}
                    />
                )
            }

        },
        {
            field: "sGroupName",
            headerName: "ชื่อกลุ่มผู้ใช้งาน",
            headerAlign: "center",
            align: "Left",
            sortable: true,
            width: 220,
            flex: 2,
        },
        {
            field: "sRoleName",
            headerName: "ชื่อบทบาทหน้าที่ผู้ใช้งาน",
            headerAlign: "center",
            align: "Left",
            sortable: true,
            width: 300,
            flex: 2,
        },
        {
            field: "nTotalMenu",
            headerName: "สิทธิ์การใช้งาน",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 130,
            flex: 0.8,
            renderCell: (item) => {
                if (item.row.nTotalMenu > 0) {
                    return (
                        <>
                            <Typography variant="body1">{item.row.nTotalMenu}</Typography>
                            <SubjectIcon
                                sx={{
                                    color: "#930012 !important",
                                    "&:hover": {
                                        color: "black !important",
                                    },
                                    cursor: "pointer",

                                }}
                                onClick={() => onOpenModal(item.row.sID)}
                            />
                        </>
                    );
                } else {
                    return (
                        <>
                            <Typography variant="body1">{item.row.nTotalMenu}</Typography>
                            <SubjectIcon
                                sx={{
                                    color: "#d7d7d7 !important",
                                    "&:hover": {
                                        color: "#d7d7d7 !important",
                                    },
                                    cursor: "pointer",
                                }}

                            />
                        </>
                    );
                }
            },
        },
        {
            field: "sUpdate",
            headerName: "แก้ไขล่าสุด",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 200,
            flex: 1.3,
            renderCell: (item) => {
                return (
                    <>
                        <Grid sx={{ mr: "4px" }}>
                            {item.row.sUpdate}
                        </Grid>
                        <IconButton size="small"
                            onClick={(e) => { handleClick(e); handleViewInfo(item.row); }}
                        >
                            <InfoIcon
                                style={{ color: "#6e130d", cursor: "pointer" }}
                            />
                        </IconButton>
                    </>
                )
            }
        },
        {
            field: "sStatus",
            headerName: "สถานะ",
            headerAlign: "center",
            align: "center",
            sortable: true,
            width: 120,
            flex: 0.8,
            renderCell: (item) => {
                return (
                    <>
                        {EnumStatus.Active == item.row.nStatus &&
                            <Tooltip title={item.row.sStatus}>
                                <Chip
                                    size="medium"
                                    label={item.row.sStatus}
                                    style={{
                                        color: "rgb(22 187 68)",
                                        backgroundColor: "rgb(231 255 237)",
                                        margin: "0.2rem",
                                        fontSize: "0.8rem"
                                    }}
                                />
                            </Tooltip>
                        }
                        {EnumStatus.isActive == item.row.nStatus &&
                            <Tooltip title={item.row.sStatus}>
                                <Chip
                                    size="medium"
                                    label={item.row.sStatus}
                                    style={{
                                        color: "#f1416c",
                                        backgroundColor: "#fff5f8",
                                        margin: "0.2rem",
                                        fontSize: "0.8rem"
                                    }}
                                />
                            </Tooltip>

                        }


                    </>
                )
            }
        },
    ];

    const getTableGroup = (p: PaginationInterface) => {
        setLoadingTable(true);
        let Param = {
            ...p,
        };
        AxiosFn.Post(`Group/getTableGroup`, Param, (result) => {
            setLoadingTable(false);
            setDataRow({
                ...p,
                arrRows: [...result.lstDataGroup],
                nDataLength: result.ObjTable?.nDataLength,
                nPageIndex: result.ObjTable?.nPageIndex,
            });
            let arrOpt = [];
            for (let i = 1; i <= result.nOrder; i++) {
                arrOpt.push({ label: `${i}`, value: `${i}` });
            }
            setLstOrder([...arrOpt]);
        });
    };

    //#region onChangeOrder
    const onChangeOrder = async (sID, nOrder) => {
        let param = {
            sID: sID,
            NewOrder: nOrder,
            Table: "TbGroupRole",
            Column: "nGroupID",
            TypeColumn: "",
            TypeID: 0,
            sLocation: location.pathname
        };
        AxiosFn.Post("Group/OnChangeOrder", param, (res) => {
            getTableGroup(dataRow);
        }, (err) => {
            if (!err.response) {
                DialogFn.Warning(err.Message);
            }
        });
    };

    //#endregion
    const onDelete = (e) => {
        DialogFn.Submit("คุณต้องการลบข้อมูลใช่หรือไม่ ?", () => {
            let objParam = {
                lstID: e,
                sLocation: location.pathname
            }

            AxiosFn.Post(`Group/RemoveDataTable`, objParam, (result) => {
                if (result.nStatusCode === 200) {
                    DialogFn.Success("ลบสำเร็จ", () => {
                        getTableGroup(dataRow);
                    });
                }
            });
        });
    };

    useEffect(() => {
        getTableGroup(dataRow);
        getFormInitial();
    }, []);

    const goToEdit = (sID: string) => {
        navigate(`/GroupForm?sID=${encodeURI(sID)}`);
    };


    const onOpenModal = (e) => {
        setisOpenPermission(true);
        AxiosFn.Post(
            `Group/GetDataPermission`,
            { sID: e },
            (res) => {
                setLstPermission(res.lstPermissionDeteil || []);
            },
            (err) => {
                if (!err.response) {
                    DialogFn.Warning(err.Message);
                }
            }
        );
    };

    //Filter Search
    const filter: FilterFieldInterface[] = [
        { sTypeFilterMode: "input", sLabel: "ชื่อกลุ่มผู้ใช้งาน", sFieldName: "sGroupName", nGridLG: 4, nGridMD: 4, nGridSM: 6, nGridXS: 12 },
        { sTypeFilterMode: "multiselect", sLabel: "ชื่อบทบาทหน้าที่ผู้ใช้งาน", sFieldName: "lstRole", optionSelect: arrUserRole, nGridLG: 4, nGridMD: 4, nGridSM: 6, nGridXS: 12 },
        {
            sTypeFilterMode: "select", sLabel: "สถานะ", sFieldName: "sStatus",
            optionSelect: [
                {

                    label: "ใช้งาน",
                    value: "1"
                },
                {

                    label: "ไม่ใช้งาน",
                    value: "0"
                },

            ],
            nGridLG: 2, nGridMD: 2, nGridSM: 6, nGridXS: 12
        },
    ];
    return (
        <React.Fragment>
            <Grid item xs={12} sx={{ mt: 1 }}>
                <DataGrid
                    sTableID='tb1'
                    columns={dataColumn}
                    rows={dataRow}
                    modeFilter={1}
                    onLoadData={getTableGroup}
                    onDelete={onDelete}
                    isLoading={loadingTable}
                    isHiddenToolHead={false}
                    filterField={filter}
                    onRowSelectable={(p) => !p.row.isDelete}
                    isShowCheckBox={isPermission}
                />
            </Grid>

            <DialogPreview
                IsOpen={isOpenPermission}
                IsBackdropClick={false}
                onClose={() => { setisOpenPermission(false); }}
                JsxDialogAction
                CloseSave={false}
                Close={false}
                sMaxWidth='sm'
                bgColor={"#a07300"}
                Color='white'
                Title={'เมนู / ฟังก์ชัน'}
            >
                <Grid container justifyContent={"center"} >
                    {lstPermission.map((m) => (
                        <>
                            <Grid item container xs={12} md={12} spacing={1} sx={{ mt: "5px", marginLeft: 3 }}>
                                <Grid item container md={8} >
                                    <Typography style={{ color: "#212836", fontSize: "16px", fontWeight: m.nfontWeight ? m.nfontWeight : 400 }}> {m.nLevel == 2 && <Circle sx={{ color: "#212836", height: "7px", marginLeft: 2 }} />}{m.sMenuName} </Typography></Grid >
                                <Grid item container md={4} >
                                    <Typography style={{ color: "White", fontSize: "15px", fontWeight: 400 }}>
                                        <Box component="span" sx={{ p: "3px", borderRadius: 1, width: "100%", height: 5, backgroundColor: m.sColor, }}>
                                            &nbsp; {m.sPermissionName} &nbsp;
                                        </Box>
                                    </Typography>
                                </Grid>

                            </Grid>
                        </>
                    ))}

                </Grid>
            </DialogPreview >

            {/* pop over */}
            <Popover
                id={`sUpdateName`}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <Typography sx={{ p: 2 }}>{sUpdateName}</Typography>
            </Popover>
        </React.Fragment >
    )
}
export default GroupList;
